import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  contentTime: {
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'end',
    gap: '12px'
  },
  formControl: {
    display: 'flex',
    // alignItems: 'center',
    gap: '8px'
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& p': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_
    }
  },
  inputSwitch: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    height: '35px'
  },
  switchContainer: {
    marginBottom: '10px',
    transition: 'margin 0.2s ease'
  },
  switchContainerActive: {
    marginBottom: '0px'
  },
  contentWeekDays: {
    display: 'flex',
    marginTop: '4px'
  },
  label: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  textUntil: {
    marginTop: '25px'
  },
  boxAttention: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textAttention: {
    backgroundColor: theme.palette.red_200.main,
    color: theme.palette.red_100.main,
    fontSize: '.875rem',
    padding: '6px 16px',
    borderRadius: '8px'
  }
}))
